import { useDispatch } from 'react-redux';
import { Tracker } from '../store/tracking/action-creators';
import { bindActionCreators } from 'redux';
export const useTracker = () => {
  const dispatch = useDispatch();
  return bindActionCreators(Tracker, dispatch);
};